/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as KitimatLogo } from "cms/assets/images/kitimat-logo-horizontal.svg";
import { FooterContact } from "./footer-column/footer-contact";
import { FooterInTouch } from "./footer-column/footer-in-touch";
import { FooterResources } from "./footer-column/footer-resources";

const FooterMain = () => {
    return (
        <div className="footer-main">
            <div className="footer-main-content">
                <NavLink to="/" className="footer-logo">
                    <KitimatLogo alt="kitimat-logo" />
                </NavLink>
                <div className="footer-columns">
                    <FooterContact />
                    <FooterInTouch />
                    <FooterResources />
                </div>
            </div>
        </div>
    );
};

export { FooterMain };
